import { Badge } from "@/components/base/badges/badges";
import { PayoutSetupStatus } from "@fp/admin-api-client/types/payoutSetupStatus.js";

interface PayoutSetupStatusBadgeProps {
  status: PayoutSetupStatus;
}

const statusConfig: Record<
  PayoutSetupStatus,
  { label: string; color: "gray" | "warning" | "blue" | "success" | "error" }
> = {
  [PayoutSetupStatus.OrganizationRelationshipNeeded]: { label: "Invitation Needed", color: "gray" },
  [PayoutSetupStatus.NotStarted]: { label: "Setup Pending", color: "gray" },
  [PayoutSetupStatus.IdentityVerificationPending]: { label: "Verification Pending", color: "warning" },
  [PayoutSetupStatus.PayoutMethodNeeded]: { label: "Payout Method Needed", color: "blue" },
  [PayoutSetupStatus.BankAccountAwaitingReview]: { label: "Bank Under Review", color: "warning" },
  [PayoutSetupStatus.BankAccountRejected]: { label: "Bank Rejected", color: "error" },
  [PayoutSetupStatus.BankAccountUnlinked]: { label: "Bank Unlinked", color: "error" },
  [PayoutSetupStatus.BankAccountReturned]: { label: "Bank Returned Payment", color: "error" },
  [PayoutSetupStatus.DebitCardNotPayoutEligible]: { label: "Card Not Eligible", color: "error" },
  [PayoutSetupStatus.DebitCardPayoutsUnavailable]: { label: "Card Payouts Unavailable", color: "warning" },
  [PayoutSetupStatus.Ready]: { label: "Ready", color: "success" },
};

export const PayoutSetupStatusBadge = ({
  status,
}: PayoutSetupStatusBadgeProps) => {
  const config = statusConfig[status];

  return (
    <Badge size="sm" color={config.color}>
      {config.label}
    </Badge>
  );
};
